import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes,
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../enums';
import { MenuTextMapping } from '../utils/appConstant';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import UserList from '../modules/users/list';
import UserAddEditView from '../modules/users/addEditView';

const Users: React.FC = () => {
  const { isSystemAdmin, permissions } = useContext(AuthContext);
  return (
    <Routes>
      <Route path={AuthRoutes.users}>
        <Route
          path={AuthRoutes.users + RouteParamsTypes.blank}
          element={
            <ProtectedRoute
              component={UserList}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.users + RouteParamsTypes.add}
          element={
            <ProtectedRoute
              component={UserAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.users + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={UserAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.users + RouteParamsTypes.view + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={UserAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.View] }]}
            />
          }
        />
      </Route>

      <Route
        path={RouteParamsTypes.blank}
        element={
          <Navigate
            replace
            to={{
              pathname:
                redirectBasedOnPermission(isSystemAdmin, permissions, MenuTextMapping.users) ||
                Modules.error + NonAuthRoutes.forbidden,
            }}
          />
        }
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Users;
